import { Table as OriginalTable } from "@tiptap/extension-table";

export const MIN_CELL_WIDTH = 75;
export const MAX_CELL_WIDTH = 500;
export const MIN_ROW_HEIGHT = 34;
export const MAX_ROW_HEIGHT = 500;
export const TABLE_RESIZE_HANDLE_THRESHOLD = 6;

export const Table = OriginalTable.extend({
  addOptions() {
    return {
      ...this.parent?.(),
      resizable: false,
      cellMinWidth: MIN_CELL_WIDTH,
    };
  },

  addAttributes() {
    return {
      ...this.parent?.(),
      showHorizontalLines: {
        default: true,
      },
      showVerticalLines: {
        default: true,
      },
    };
  },
});
